export const joinClass = (...parts) => parts.filter(Boolean).join(" ");
